module.exports = __webpack_public_path__ + "img/Frame 2131.e3d76072.png";